import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ExceptionService } from '../core';
import { API } from '../shared/constants';
import { LoginImage } from './loginimage.model';
import { HttpClientService } from '../shared/http.client.service';

let loginimageUrl = API.ENDPOINT.LOGINIMAGE;

@Injectable()
export class LoginImageService {

  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(
    private _httpClientService: HttpClientService,
    private exceptionService: ExceptionService
  ) { }

  getLoginImage() {
     return this._httpClientService
      .get(`${loginimageUrl}published`)
      .toPromise()
      .then(res => {
        return res.json();
      })
      .catch(this.exceptionService.catchBadResponse);
  }

  addLoginImage() {
   return this._httpClientService
      .post(`${loginimageUrl}persist`, {})
      .toPromise()
      .then(res => {
        return res.json();
      })
      .catch(this.exceptionService.catchBadResponse);
  }

  updateLoginimage(loginimage: any) {
    return this._httpClientService
      .post(`${loginimageUrl}persist`, JSON.stringify(loginimage), this.headers)
      .toPromise()
      .then(res => res.json())
      .catch(this.exceptionService.catchBadResponse);
  }

  deleteLoginimage(id: any) {
    return this._httpClientService
      .delete(`${loginimageUrl}delete/`+id)
      .toPromise()
      .then(res => res.json())
      .catch(this.exceptionService.catchBadResponse);
  }

  private extractData<T>(res: Response) {
    if (res.status < 200 ||
        res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }

    let body = res.json ? res.json() : null;
    return <T>(body || {});
  }

}



// WEBPACK FOOTER //
// ./src/app/loginImage/loginimage.service.ts